module.exports = __webpack_public_path__ + "static/media/podcast_bpco.cb605b83.png";